<template>
  <l-control position="topleft">
    <div class="d-flex">
      <div
        @click="toggleControl"
        style="border-radius: 5px; cursor: pointer;"
        class="d-flex justify-content-start align-items-start p-1"
      >
        <img src="/img/kml_file_white.png" style="width:28px;" />
      </div>
      <div v-if="showKMLControl" class="px-2" style="width: 100%;">
        <b-form-file
          accept=".kml"
          @change="handleKmlUpload"
          class="m-2"
        />
      </div>
    </div>
  </l-control>
</template>

<script>
import omnivore from "@mapbox/leaflet-omnivore"; // Ensure this is installed
export default {
  name: "KmlUploadControl",
  props: {
    mapRefName: {
      type: Object
    }
  },
  data() {
    return {
      showKMLControl: false,
      kmlLayer: null
    };
  },
  methods: {
    toggleControl() {
      this.showKMLControl = !this.showKMLControl;
    },
    handleKmlUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const kmlContent = e.target.result;
        console.log("KML Content Loaded:", kmlContent);

        const map = this.mapRefName;
        if (!map) {
          console.warn("Map reference not found.");
          return;
        }

        // Remove existing KML layer if any
        if (this.kmlLayer && map.hasLayer(this.kmlLayer)) {
          map.removeLayer(this.kmlLayer);
        }

        // Create new KML layer and add it to map
        this.kmlLayer = omnivore.kml.parse(kmlContent);
        this.kmlLayer.addTo(map);

        // Zoom to layer bounds
        map.fitBounds(this.kmlLayer.getBounds());
      };

      reader.readAsText(file);
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style>
